import { ShiftAttributes } from '@/types'
import { CreateShiftMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  defaultValues?: Partial<ShiftAttributes>
  onSuccess: () => void
}

export const Form = ({ defaultValues, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading
  } = useForm<CreateShiftMutation, ShiftAttributes, never, never>({
    defaultValues: {
      eventId: '',
      userId: '',
      start: (new Date).toISOString(),
      finish: (new Date).toISOString(),
      rateCents: 0,
      shiftRoleId: '',
      ...defaultValues,
    },
    mutation: CreateMutation,
    resultKey: 'createShift',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Person', field: 'userId', type: 'user' }) }
      { formBuilder.buildField({ name: 'Role', field: 'shiftRoleId', type: 'shift-role' }) }
      <div className="grid grid-cols-2 gap-6">
        { formBuilder.buildField({ name: 'Start', field: 'start', type: 'datetime' }) }
        { formBuilder.buildField({ name: 'Finish', field: 'finish', type: 'datetime' }) }
      </div>
      { formBuilder.buildField({ name: 'Rate', field: 'rateCents', type: 'currency' })}
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
